var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.66797H3.00004C2.55801 1.66797 2.13409 1.84356 1.82153 2.15612C1.50897 2.46868 1.33337 2.89261 1.33337 3.33464V16.668C1.33337 17.11 1.50897 17.5339 1.82153 17.8465C2.13409 18.159 2.55801 18.3346 3.00004 18.3346H13C13.4421 18.3346 13.866 18.159 14.1786 17.8465C14.4911 17.5339 14.6667 17.11 14.6667 16.668V6.66797M9.66671 1.66797L14.6667 6.66797M9.66671 1.66797V6.66797H14.6667M11.3334 10.8346H4.66671M11.3334 14.168H4.66671M6.33337 7.5013H4.66671",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxt);
export default __webpack_public_path__ + "static/media/icon-txt.b3bf8ea2b07d516df5ec2f9754b88da7.svg";
export { ForwardRef as ReactComponent };